import useSWR from 'swr';
import container from 'src/container';
import { Organization } from 'src/domain/organization';
import { UserRole } from 'src/domain/user';

const {
    cradle: { munduClient },
} = container;

const fetchOrganizationB2Cs = async (): Promise<Organization[]> => {
    const organizations = await munduClient.listOrganizations();
    return organizations.filter(
        organization => organization.role === UserRole.organizationB2C,
    );
};

export const useOrganizationB2Cs = () => {
    const { data, error, mutate } = useSWR('organizations-b2c', () =>
        fetchOrganizationB2Cs(),
    );

    return {
        organizations: data || [],
        mutate,
        isLoading: !error && !data,
        isError: error,
    };
};
